<template>
  <div class="product">
    <!-- 视差背景横幅 -->
    <div class="parallax-banner">
      <div class="overlay"></div>
      <div class="banner-content">
        <h1 class="animate__animated animate__fadeInDown">业务介绍</h1>
        <p class="animate__animated animate__fadeInUp">BUSINESS INTRODUCTION</p>
      </div>
    </div>

    <div class="product-content" v-loading="loading">
      <div class="content-container">
        <div class="business-grid">
          <div class="business-card" v-for="(item, index) in newsList" :key="index"
               @click="routeLink(item.id)">
            <div class="card-image" :style="{ backgroundImage: `url(${item.filePath})` }">
              <div class="card-overlay">
                <div class="overlay-content">
                  <h3>{{ item.name }}</h3>
                  <span class="view-more">查看详情</span>
                </div>
              </div>
            </div>
            <div class="card-content">
              <h3>{{ item.name }}</h3>
              <div class="card-line"></div>
              <!-- <div class="card-description" v-html="getShortDescription(item.description)"></div> -->
              <div class="card-description">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product {
  background: #fff;

  // 视差背景横幅
  .parallax-banner {
    height: 30vh;
    background: url('../assets/img/bgtop.jpg') center/cover fixed;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 1;

      h1 {
        font-size: 2.5rem;
        margin-bottom: 0.8rem;
        font-weight: 600;
      }

      p {
        font-size: 1rem;
        letter-spacing: 0.2rem;
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .product-content {
    margin-top: -30px;
    position: relative;
    z-index: 2;
    padding: 0 0 4rem;

    .content-container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 3rem 3rem 3rem;
      background: white;
      border-radius: 15px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

      .business-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 2rem;
        margin: 1rem 0 0;
      }

      .business-card {
        background: white;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
        cursor: pointer;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        border: 1px solid #f0f0f0;

        &:hover {
          transform: translateY(-6px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          border-color: #e6e6e6;

          .card-image {
            transform: scale(1.05);

            .card-overlay {
              opacity: 1;
              
              .overlay-content {
                transform: translateY(0);
                opacity: 1;
              }
            }
          }

          .card-content {
            background: #f8f9fa;

            .card-line {
              width: 40%;
            }

            h3 {
              color: #409EFF;
            }
          }
        }

        .card-image {
          height: 160px;
          background-size: cover;
          background-position: center;
          position: relative;
          transition: all 0.4s ease;
          padding: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }

          .card-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(to top, rgba(64, 158, 255, 0.9), rgba(64, 158, 255, 0.7));
            opacity: 0;
            transition: all 0.4s ease;
            display: flex;
            align-items: center;
            justify-content: center;

            .overlay-content {
              text-align: center;
              color: white;
              transform: translateY(20px);
              opacity: 0;
              transition: all 0.4s ease;
              padding: 0 1rem;

              h3 {
                font-size: 1.2rem;
                margin-bottom: 0.8rem;
                font-weight: 500;
              }

              .view-more {
                display: inline-block;
                padding: 0.5rem 1.2rem;
                border: 1.5px solid white;
                border-radius: 20px;
                font-size: 0.85rem;
                transition: all 0.3s ease;

                &:hover {
                  background: white;
                  color: #409EFF;
                }
              }
            }
          }
        }

        .card-content {
          padding: 1.2rem;
          background: white;
          transition: all 0.3s ease;
          text-align: center;

          h3 {
            font-size: 1.1rem;
            color: #2c3e50;
            margin-bottom: 0.5rem;
            font-weight: 500;
            transition: all 0.3s ease;
          }

          .card-line {
            width: 25px;
            height: 2px;
            background: #409EFF;
            margin: 0.5rem auto;
            transition: all 0.4s ease;
          }

          .card-description {
            color: #666;
            font-size: 0.85rem;
            line-height: 1.5;
            margin: 0;
            max-height: 2.8em;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;

            :deep(p) {
              margin: 0;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1400px) {
    .product-content .content-container {
      .business-grid {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }

  @media (max-width: 1024px) {
    .product-content .content-container {
      .business-grid {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  @media (max-width: 1200px) {
      .parallax-banner {
        height: 25vh!important;
      }
    }

  @media (max-width: 768px) {
    .parallax-banner {
      height: 25vh;

      .banner-content {
        h1 {
          font-size: 2rem;
        }

        p {
          font-size: 0.8rem;
        }
      }
    }

    .product-content {
      margin-top: -25px;
      padding: 0 0 3rem;

      .content-container {
        padding: 2rem 1rem 0;

        .business-grid {
          grid-template-columns: repeat(1, 1fr);
          gap: 1.2rem;
          margin: 1rem 0 2rem;
        }

        .business-card {
          .card-image {
            height: 140px;
          }

          .card-content {
            padding: 1rem;

            h3 {
              font-size: 1rem;
            }

            .card-description {
              font-size: 0.8rem;
            }
          }
        }
      }
    }
  }
}

// 动画类
.animate__animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.animate__fadeInDown {
  animation-name: fadeInDown;
}

.animate__fadeInUp {
  animation-name: fadeInUp;
}
</style>

<script>
export default {
  data() {
    return {
      loading: true,
      newsList: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`business/list`)
        .then(response => {
          this.newsList = response.data.data;
          for (let obj of this.newsList) {
            obj.filePath = this.imgserver + obj.filePath;
          }
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
          this.loading = false;
        });
    },
    routeLink(id) {
      this.$router.push({ name: "Tabe", query: { id: id }});
    },
    getShortDescription(description) {
      if (!description) return '专业服务，品质保证';
      
      const div = document.createElement('div');
      div.innerHTML = description;
      const text = div.textContent || div.innerText;
      
      // 减少显示字符数
      return text.length > 50 ? text.slice(0, 50) + '...' : text;
    }
  }
};
</script>